export function formatImageContent(contentData) {
    if (!contentData) {
        return ;
    }

    let tableData = contentData['table']
    let textData = contentData['text']
    let imageData = contentData['image'] // pdf会返回image data

    if ((!imageData || !imageData.length) && (!textData || !textData.length) && (!tableData|| !tableData.length)) {
        return
    }
    if (imageData && imageData.length > 0) {

        imageData.forEach(item => {
            tableData = tableData.concat(item['table'])
            textData = textData.concat(item['text'])
        })
    }
    let text, orgTextBox, indexList
    if (textData) {
        [text, orgTextBox, indexList] = getTextStr(textData)
    }

    let table
    if (tableData){
        table = getTableContentToApi(tableData)
    }
    const textList = []
    if (text) {
        textList.push(text)
    }
    const context = {
        "tables": table,
        "texts": textList,
    }
    // console.log("context", context)
    return context
}

export function getVisionNoStructText(contentData) {
    return [""]
    if (!contentData || !contentData['no_struct_text'] || !contentData['no_struct_text'].length) {
        return ""
    }
    return contentData['no_struct_text']
}

function getTableContentToApi(tableDataList) {
    let resTable = []
    try{
        for (let i = 0; i < tableDataList.length; i++) {
            // const tablePosition = tableDataList[i]['position']
            // const [x1, y1, x2, y2] = tablePosition
            const tableDataItem = []
            if (tableDataList[i] && tableDataList[i]['info'] ){
                tableDataList[i]['info'].map((item) => {
                    if (item["content"] !== "") {
                        tableDataItem.push({
                            "row": item['row'],
                            "col": item["col"],
                            "content": item["content"],
                        })
                    }
                })
            }
            resTable.push(tableDataItem)
        }
    } catch (err) {
        console.log(`getTextStr getTableContentToApi err: ${err}; data: `, tableDataList)
    }

    return resTable
}

function getTableBoxToCfdMap(tableDataList) {
    let resMap = {}
    for (let i = 0; i < tableDataList.length; i++) {
        console.log("tableDataList[iformatImageContent]", tableDataList[i])
        const tablePosition = tableDataList[i]['position']
        const [x1, y1, x2, y2] = tablePosition
        tableDataList[i]['info'].map((item) => {
            if (item["content"] != "") {
                const startPosition = getStartPositionKey(item['box'][0] + x1, item['box'][1] + y1)
                const value = item["confidence"]
                resMap[startPosition] = value
            }
        })
    }
    return resMap
}

function getStartPositionKey(x1, y1) {
    return `${x1}_${y1}`
}

// todo 需要先将文本的坐标对齐，再去计算文字的顺序，否则， 偏差几个像素的高度的文字将失去顺序，会变成下一行
function getTextStr(ocrData, threshold = 0.9) {
    if (!ocrData) {
        return [null, null, null]
    }
    // console.log("ocrData", ocrData)

    // 拼接结果文本
    let result = "";
    let filteredData = null
    // 过滤掉识别概率低于阈值的文本
    try {
        filteredData = ocrData.filter(item => item && item[1] && item[1][1] >= threshold).map(item => {
            const coordinates = item[0];
            const text = item[1][0];
            const confidence = item[1][1];
            // 计算每个文本框的平均 x 和 y 坐标
            const avgX = (coordinates[0][0] + coordinates[1][0] + coordinates[2][0] + coordinates[3][0]) / 4;
            const avgY = (coordinates[0][1] + coordinates[1][1] + coordinates[2][1] + coordinates[3][1]) / 4;
            return {
                text,
                avgX,
                avgY,
                confidence,
                box: [coordinates[0][0], coordinates[0][1], coordinates[2][0], coordinates[2][1]]
            };
        });
    }catch(err) {
        console.log(`getTextStr filteredData err: ${err}; data:`, ocrData)
        return  [result, "", []]
    }

    // 按 y 坐标和 x 坐标进行排序，保证文本按上下左右的顺序排列
    filteredData.sort((a, b) => (a.avgY - b.avgY) || (a.avgX - b.avgX));

    let prevX = null, prevY = null;

    const indexList = []
    filteredData.forEach(({text, avgX, avgY, box}, index) => {
        if (prevY === null) { // 初始化第一行
            result += text;
        } else {
            // 判断是否换行：如果 y 轴位置差较大则换行
            if (Math.abs(avgY - prevY) > 30) {  // 30 是换行的 y 轴阈值，可以根据需要调整
                result += "\n" + text;
            } else {
                // 判断是否加空格：如果 x 轴位置差较大则加空格
                if (Math.abs(avgX - prevX) > 50) {  // 50 是空格的 x 轴阈值，可以根据需要调整
                    result += " " + text;
                } else {
                    result += text;
                }
            }
        }
        prevX = avgX;
        prevY = avgY;
        indexList.push(result.length)
    });
    return [result, filteredData, indexList]
}


function findTextBoxes(textStr, orgTextBoxList, boxIndexList, targetStrList) {
    const res = []
    targetStrList.forEach(targetStr => {
        const startStrIndex = textStr.indexOf(targetStr)
        if (startStrIndex >= 0) {
            let startBoxIndex = -1
            for (let i = 0; i < boxIndexList.length; i++) {
                if (boxIndexList[i] === startStrIndex) {
                    startBoxIndex = i + 1
                    break
                }
                if (boxIndexList[i] > startStrIndex) {
                    startBoxIndex = i
                    break
                }
            }

            let endBoxIndex = startBoxIndex
            const endStrIndex = startStrIndex + targetStr.length
            for (let j = endBoxIndex; j < boxIndexList.length; j++) {
                if (boxIndexList[j] >= endStrIndex) {
                    endBoxIndex = j
                    break
                }
            }

            const perTargetBoxes = []
            for (let targetBoxIndex = startBoxIndex; targetBoxIndex <= endBoxIndex; targetBoxIndex++) {
                // 为了兼容性，统一返回四个顶点坐标, [[p1,p2,p3,p4], confidence]
                perTargetBoxes.push([orgTextBoxList[targetBoxIndex]['box'], orgTextBoxList[targetBoxIndex]['confidence']])
            }
            res.push(perTargetBoxes)
        }
    })
    return res
}

function findTextLocationIndex(indexList, targetIndex) {
    for (let i = 0; i < indexList.length; i++) {
        if (indexList[i] > targetIndex) {
            return i - 1
        }
    }
}


// export function getImageMatchBoxes(contentData, matchData) {
//     const tableData = contentData['table']
//     const tableBoxToCfdMap = getTableBoxToCfdMap(tableData)
//
//     console.log("tableBoxToCfdMap and matchData", tableBoxToCfdMap, matchData)
//
//     const textData = contentData['text']
//     const [textStr, orgTextBox, indexList] = getTextStr(textData)
//     console.log("orgTextBox", orgTextBox);
//     let res = []
//
//     function getItemBoxPosition(matchItem) {
//
//         // todo 这里默认答案要么在table中，要么在text中， 将box 与 confidence作为一个对象返回，如果需要兼容，则需要修改结构
//         if (matchItem['value_source_text'].length > 0) {
//             return {
//                 keyword: matchItem["question"],
//                 box: findTextBoxes(textStr, orgTextBox, indexList, matchItem["value_source_text"]),
//                 value: matchItem['value']
//             }
//         } else if (matchItem['value_source_position'].length > 0) {
//             const tableMatchBox = []
//             matchItem['value_source_position'].forEach((item) => {
//                 console.log("'value_source_position' item", item)
//                 const tableConfidence = tableBoxToCfdMap[getStartPositionKey(item[0], item[1])]
//                 if (!tableConfidence) {
//                     throw `tableConfidence not found, please check!! contact TLS engineer`
//                 }
//                 // 为了兼容性，统一返回四个顶点坐标, [[p1,p2,p3,p4], confidence]
//                 tableMatchBox.push([[[item[0], item[1]], [item[2], item[1]], [item[2], item[3]], [item[0], item[3]]], tableConfidence])
//             })
//             return {
//                 keyword: matchItem["question"],
//                 box: tableMatchBox,
//                 value: matchItem['value']
//             }
//         }
//     }
//
//
//     matchData.forEach((item, index) => {
//         const boxRes = getItemBoxPosition(item)
//         if (boxRes) {
//             res.push(boxRes)
//         }
//     })
//     return res
// }

export function drawBoxesOnImage(thumbnail, boxes) {
    return new Promise((resolve, reject) => {
        // 创建一个新的 Image 对象
        const image = new Image();
        image.src = thumbnail; // 传入的原始缩略图路径或 base64 数据

        // 图像加载成功后执行
        image.onload = function() {
            // 创建一个 canvas 元素
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // 设置 canvas 的宽高与图像相同
            canvas.width = image.width;
            canvas.height = image.height;

            // 在 canvas 上绘制原始图像
            ctx.drawImage(image, 0, 0);
            console.log("start drawBoxesOnImage", boxes)
            // 遍历 boxes 数组，绘制每一个框
            for (const boxesPerKeyword of boxes) {
                for (const box of boxesPerKeyword) {
                    console.log("drawBoxesOnImage box", box)
                    if (box && box.length === 4) { // 确保 box 有四个坐标点
                        const xCoords = box.map(coord => coord[0]); // 提取所有 x 坐标
                        const yCoords = box.map(coord => coord[1]); // 提取所有 y 坐标

                        // 计算框的左上角坐标 (minX, minY) 和宽高
                        const left = Math.min(...xCoords) ; // 左边界
                        const top = Math.min(...yCoords) ; // 上边界
                        const width = (Math.max(...xCoords) - Math.min(...xCoords)); // 宽度
                        const height = (Math.max(...yCoords) - Math.min(...yCoords)); // 高度

                        // 绘制红色矩形框
                        ctx.strokeStyle = "red";
                        ctx.lineWidth = 5;
                        console.log("left, top, width, height", left, top, width, height)
                        ctx.strokeRect(left, top, width, height); // 绘制框
                    }
                }
            }

            // 获取带框的图像，并返回新的 base64 数据
            const modifiedImageData = canvas.toDataURL();

            // 返回带框的新缩略图
            resolve(modifiedImageData);
        };

        // 处理图片加载失败的情况
        image.onerror = function(error) {
            console.error("Image load failed: ", error);
            reject(new Error("Image load failed"));
        };
    });
}

